var exports = {
  "p$": "DMChannelView.module__emptyState___R2ZXZX",
  "AI": "DMChannelView.module__emptyStateIcon___R2ZXZX",
  "vo": "DMChannelView.module__emptyStateTitle___R2ZXZX",
  "Li": "DMChannelView.module__emptyStateDescription___R2ZXZX",
  "fX": "DMChannelView.module__callParticipantsRow___R2ZXZX",
  "gN": "DMChannelView.module__compactCallParticipantsRow___R2ZXZX",
  "Gr": "DMChannelView.module__callParticipant___R2ZXZX",
  "Gj": "DMChannelView.module__callParticipantAvatar___R2ZXZX",
  "I9": "DMChannelView.module__callParticipantRinging___R2ZXZX",
  "rV": "DMChannelView.module__call-participant-ring-pulse___R2ZXZX",
  "Jn": "DMChannelView.module__callBanner___R2ZXZX",
  "nY": "DMChannelView.module__callBannerBody___R2ZXZX",
  "c7": "DMChannelView.module__callBannerResizable___R2ZXZX",
  "oo": "DMChannelView.module__callControlBarSection___R2ZXZX",
  "Pf": "DMChannelView.module__callControlBarInner___R2ZXZX",
  "tX": "DMChannelView.module__callControls___R2ZXZX",
  "pm": "DMChannelView.module__callBannerMobile___R2ZXZX",
  "h8": "DMChannelView.module__callBannerMobileLabel___R2ZXZX",
  "ZI": "DMChannelView.module__callControlsMobile___R2ZXZX",
  "IX": "DMChannelView.module__compactCallResizeHandle___R2ZXZX",
  "rF": "DMChannelView.module__compactCallResizePill___R2ZXZX",
};

module.exports = exports;
